import { localStorage } from '@/util/storage'
import { Auth } from '@/networks/api'

export const getToken = async ({ store }) => {
  const handleError = () => {
    // login()
    store.commit('LOGOUT')
  }
  try {
    const result = await Auth.getToken({ rootState: store.state })
    const { status } = result.data
    // 用户未登录 status === 9 等价于老接口的401状态
    if(Number(status) === 9) {
      handleError()
    } else {
      store.commit('SET_USERINFO', result.data)
      store.commit('SET_USERISLOGIN', store.state.user.isLogin)
    }
  } catch (e) {
    // const response = e.response
    // const status = response && response.status
    // if (status === 401) {
    //   handleError()
    //   return
    // }
    console.log('====GET_TOKEN err=====', e)
  }
}

const getAccessToken = async ({ store }, immediately) => {
  if (store.state.user.isLogin) return
  const tokenTimer = 1 * 60 * 1000
  const lastRequestTime = localStorage.getItem('lastRequestTime').value || 0
  const isRequest = new Date().getTime() - lastRequestTime > tokenTimer
  if (isRequest || immediately) {
    localStorage.setItem('lastRequestTime', {
      value: new Date().getTime()
    })
    await getToken({ store })
  }
}

export default getAccessToken



// WEBPACK FOOTER //
// ./src/util/requestToken.js